let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4a7Nq")).then(() => parcelRequire('8XGHT'));